/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { MISSION_VIEW_ADS_EXAM_SKU } from "../../../utils/constants/constants";
import { genSignature, getNonce } from "../../../utils/helpers/helpers";
import AlertDialog from "../dialog/AlertDialog";
import CongratulationAlertDialog from "../dialog/CongratulationAlertDialog";
import GoogleAdDialog from "../dialog/GoogleAdDialog";
import { commonActions } from "../redux/actions";

type TProps = {
  openAlertDialog: boolean;
  setOpenAlertDialog: any;
  triggerFunc: () => void;
  cancelFunction?: () => void;
  isShowCongratulation?: boolean;
  isUpdateUserInfo?: boolean;
};

export default function ViewAdsEarnDiamond({
  openAlertDialog,
  setOpenAlertDialog,
  triggerFunc,
  cancelFunction,
  isShowCongratulation = false,
  isUpdateUserInfo = false
}: TProps) {
  const [openGgAd, setOpenGgAd] = useState(false);
  const dispatch = useDispatch();
  const { congratulation } = useSelector((state: { commonNew }) => state.commonNew);
  const handleViewAds = () => {
    const dataCompleteMissionPre = {
      sku: MISSION_VIEW_ADS_EXAM_SKU,
      timestamp: moment().unix(),
      nonce: getNonce()
    };
    const dataCompleteMission = {
      ...dataCompleteMissionPre,
      signature: genSignature(dataCompleteMissionPre)
    };
    dispatch(commonActions.handleCompleteMission(dataCompleteMission));
  };
  useEffect(() => {
    if (congratulation?.isOpenCongratulation) {
      triggerFunc();
      if (!isShowCongratulation) {
        dispatch(commonActions.deleteCongratulation());
      }
    }
    if (isUpdateUserInfo) {
      dispatch(commonActions.handleGetUserInfo());
    }
  }, [congratulation?.isOpenCongratulation]);
  return (
    <div>
      {openAlertDialog && (
        <AlertDialog
          open={openAlertDialog}
          setOpen={setOpenAlertDialog}
          title={<FormattedMessage id="common.notification" />}
          content={<FormattedMessage id="Dialog.ViewAdsUnlock" />}
          triggerFunc={() => {
            setOpenGgAd(true);
          }}
          cancelFunc={cancelFunction}
          buttonOkKey="common.ok"
        />
      )}

      {openGgAd && (
        <GoogleAdDialog
          open={openGgAd}
          setOpen={setOpenGgAd}
          triggerFunc={() => {
            handleViewAds();
          }}
        />
      )}
      {openAlertDialog && congratulation?.isOpenCongratulation && isShowCongratulation && (
        <CongratulationAlertDialog
          data={congratulation?.congratulation}
          openDialog={congratulation?.isOpenCongratulation && isShowCongratulation}
          handleCloseDialog={() => dispatch(commonActions.deleteCongratulation())}
          triggerFunc={() => {
            dispatch(commonActions.deleteCongratulation());
          }}
        />
      )}
      {/* {notify?.isOpenDialog && (
        <AlertDialog
          open={notify?.isOpenDialog}
          setOpen={() => {}}
          content={`${notify?.message}(${notify?.errorCode})`}
          title="Thông báo"
          buttonOkKey="common.ok"
          triggerFunc={() => {
            dispatch(commonActions.deleteNotify());
            if (isBack) {
              router.back();
            }
          }}
          isHideCancel
          notifyError
        />
      )} */}
    </div>
  );
}
